<template>
 <div>
    <v-tooltip v-model="isOpen" top color="yellow lighten-4">
    <template v-slot:activator="{  attrs }">
      <div v-bind="attrs">{{ $t(content) }}</div>
    </template>
    <span style="color: black">
      <v-icon color="warning">mdi-alert-circle</v-icon>
      {{ $t("required") }}
    </span>
  </v-tooltip>
 </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: null
    },
    content: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      isOpen: this.open
    };
  },

  watch: {
    open() {
      this.isOpen = this.open;
    }
  }
};
</script>

<style>
</style>
